import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=c7030b38&scoped=true"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"
import style0 from "./tab.vue?vue&type=style&index=0&id=c7030b38&prod&lang=css"
import style1 from "./tab.vue?vue&type=style&index=1&id=c7030b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7030b38",
  null
  
)

export default component.exports